export const initStickyHeader = () => {
    let header = document.getElementById('header');
    const checkScroll = () => {
        let shouldAddClass = header.classList.contains('sticky') && window.scrollY > 50;
        header.classList.toggle('scrolled', shouldAddClass);
    };

    window.addEventListener('scroll', checkScroll);
    checkScroll();
};

export const initHeaderHeight = () => {
    const header = document.getElementById('header');

    if (!header) {
        return;
    }

    const setHeaderHeight = () => {
        document.documentElement.style.setProperty(
            '--header-height',
            `${header.offsetHeight}px`
        );
    };

    setHeaderHeight();

    if ('ResizeObserver' in window) {
        new ResizeObserver(setHeaderHeight).observe(header);
    } else {
        window.addEventListener('resize', setHeaderHeight);
    }
};
